import React from 'react';
import { FaPlus, FaTimes } from 'react-icons/fa';

const CarouselForm = ({ content, setContent, carouselPreviews, handleCarouselImageAdd, removeCarouselImage }) => (
  <div className="space-y-4">
    <div>
      <label className="text-sm text-gray-600 mb-2 block">Caption (Optional)</label>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        className="w-full bg-gray-100 border border-gray-300 focus:border-[#4A90E2] focus:ring-1 focus:ring-[#4A90E2] rounded-lg p-4 text-gray-900 placeholder:text-gray-400 transition-all outline-none min-h-[60px] resize-none"
        placeholder="Add a caption..."
        data-testid="carousel-caption"
      />
    </div>

    <div>
      <label className="text-sm text-gray-600 mb-2 block">Images ({carouselPreviews.length}/10)</label>
      <div className="grid grid-cols-3 gap-2 mb-2">
        {carouselPreviews.map((preview, index) => (
          <div key={`carousel-${index}`} className="relative aspect-square">
            <img src={preview} alt={`Carousel ${index + 1}`} className="w-full h-full object-cover rounded-lg" />
            <button
              type="button"
              onClick={() => removeCarouselImage(index)}
              className="absolute top-1 right-1 bg-red-500 text-white rounded-full p-1 hover:bg-red-600"
            >
              <FaTimes size={10} />
            </button>
            <span className="absolute bottom-1 left-1 bg-black/60 text-white text-xs px-2 py-0.5 rounded">{index + 1}</span>
          </div>
        ))}
        {carouselPreviews.length < 10 && (
          <label className="aspect-square flex flex-col items-center justify-center border-2 border-dashed border-gray-300 rounded-lg cursor-pointer hover:border-[#4A90E2]/50 transition-colors">
            <FaPlus className="text-2xl text-gray-400 mb-1" />
            <span className="text-xs text-gray-500">Add</span>
            <input type="file" accept="image/*" multiple onChange={handleCarouselImageAdd} className="hidden" data-testid="carousel-upload" />
          </label>
        )}
      </div>
    </div>
  </div>
);

export default CarouselForm;
